import { useEffect, useState } from 'react';

/**
 * Returns `true` after a brief delay, useful for triggering
 * CSS transition entrance animations on mount.
 */
export default function useEntranceAnimation(delayMs = 50): boolean {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimated(true), delayMs);
    return () => clearTimeout(timer);
  }, [delayMs]);

  return animated;
}
